<template>
  <svg viewBox="0 0 925 782" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio>
      <g id="BMS" transform="translate(550.000000, 408.000000)" fill="currentColor" @mouseenter="$emit('hover')" @mouseleave="$emit('hoverEnd')" :class="['hover-text-blue trans-color-fast', {'text-blue': active }]">
          <polygon id="Path" points="59.7587146 0.476958592 65 43.7434895 5.96428627 51 0 7.62060232"></polygon>
          <g id="1" transform="translate(74.000000, 5.000000)" font-family="Helvetica" font-size="24" font-weight="normal">
              <text>
                  <tspan x="0" y="23">1</tspan>
              </text>
          </g>
          <g id="3" transform="translate(23.000000, 57.000000)" font-family="Helvetica" font-size="24" font-weight="normal">
              <text>
                  <tspan x="0" y="23">3</tspan>
              </text>
          </g>
      </g>
      <g id="Hostem" transform="translate(471.000000, 214.000000)" fill="currentColor" @mouseenter="$emit('hover')" @mouseleave="$emit('hoverEnd')" :class="['hover-text-blue trans-color-fast', {'text-blue': active }]">
          <polygon id="Path" points="41.4592029 40.699481 45 67.6985364 3.30095661 73 -1.1439738e-12 45.4533264"></polygon>
          <g id="2" transform="translate(13.000000, 0.000000)" font-family="Helvetica" font-size="24" font-weight="normal">
              <text>
                  <tspan x="0" y="23">2</tspan>
              </text>
          </g>
      </g>
  </svg>
</template>

<script>
export default {
  name: 'SVG-ShoreditchBldgs',
  props: ['active']
}
</script>

<style>
</style>
